export default "/images/vendor/flag-icons/flags/1x1/gp.svg?34687ce560373f175eee32cb0902a1f1";